var render = function render(){var _vm=this,_c=_vm._self._c,_setup=_vm._self._setupProxy;return _c('div',{staticClass:"bc-button-dropdown-reset-button"},[_c('button',{staticClass:"reset-btn",on:{"click":function($event){return _vm.$emit('reset')}}},[_vm._v(" "+_vm._s(_vm.t('buttons.reset'))+" ")]),_c('button',{staticClass:"close-btn",on:{"click":function($event){return _vm.$emit('close')}}},[_c('X')],1)])
}
var staticRenderFns = []

export { render, staticRenderFns }